import { TeamLogo } from "@/components/team";

import { TeamSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemLabel } from "../SearchItemLabel";

export type TeamSearchItemViewProps = {
  item: TeamSearchItem;
};

export const TeamSearchItemView = ({ item }: TeamSearchItemViewProps) => {
  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-4 flex-2 min-w-0">
        <TeamLogo team={item.team} width={30} height={30} />
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{item.team.title}</SearchItemLabel>
        </div>
      </div>
      <div className="flex items-center shrink-0 gap-1">
        <GlobalSearchItemTypeChip type="team" />
      </div>
    </div>
  );
};
